import React from 'react';
import styled from 'styled-components';
import { media } from '../../utils/styles';
import { Button } from '../common';

const Overlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  padding: 15px;
  background: rgba(0, 0, 0, 0.49);
  z-index: 100;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  ${media.phone} {
    padding: 0;
    background: #fff;
  }
`;

const Dialog = styled.div`
  width: 488px;
  max-width: 100%;
  background: #ffffff;
  position: relative;
  padding: 88px 30px 64px;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  ${media.phone} {
    position: static;
  }
`;

const CloseButton = styled.button`
  padding: 0;
  background: none;
  position: absolute;
  top: 32px;
  right: 32px;
`;

const Text = styled.p`
  margin: 24px 0;
  font-weight: 500;
  font-size: 18px;
  line-height: 26px;
  color: #1c1c1c;
`;

export const ErrorModal = ({ onClose }) => {
  return (
    <Overlay>
      <Dialog>
        <CloseButton onClick={onClose}>
          <svg
            width="18"
            height="18"
            viewBox="0 0 18 18"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M8.99882 10.4149L16.5833 18.001L17.9976 16.5869L10.4129 9.00048L17.9976 1.41406L16.5833 0L8.99882 7.58611L1.41437 0L0 1.41406L7.58476 9.00048L0 16.5869L1.41437 18.001L8.99882 10.4149Z"
              fill="black"
            />
          </svg>
        </CloseButton>
        <svg
          width="80"
          height="80"
          viewBox="0 0 80 80"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle cx="40" cy="40" r="39" stroke="#FF6B6B" stroke-width="2" />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M39.9991 41.4113L50.7638 52.1755L52.1779 50.7612L41.4134 39.9972L52.1779 29.2331L50.7637 27.8188L39.9991 38.583L29.2345 27.8188L27.8203 29.2331L38.5849 39.9972L27.8203 50.7612L29.2345 52.1755L39.9991 41.4113Z"
            fill="#FF6B6B"
          />
        </svg>
        <Text>
          Sorry, something went wrong...
          <br />
          Please try again later.
        </Text>
        <Button onClick={onClose}>Go back</Button>
      </Dialog>
    </Overlay>
  );
};
